import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {useMessageModalContext} from '../'
import {KTSVG} from '../../../../_metronic/helpers'

type Props = {
  isUserLoading: boolean
  title?: string
  message?: string
  onOk?: any
}

const ConfirmModal = ({title, message, onClose, onOk}: any) => {
  const {showModal} = useMessageModalContext()
  const navigate = useNavigate()
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const closeCollection = () => {
    onClose(false)
  }

  const ok = () => {
    onOk()
    onClose(false)
  }

  const cancel = (withRefresh?: boolean) => {
    //if (withRefresh) {
    //    refetch()
    //}
    onClose(false)
  }
  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder'>{title}</h2>

              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={closeCollection}
                style={{cursor: 'pointer'}}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
            </div>
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              {message}

              <div className='text-center pt-15'>
                <button
                  type='reset'
                  onClick={() => cancel()}
                  className='btn btn-light me-3'
                  data-kt-users-modal-action='cancel'
                >
                  No
                </button>

                <button onClick={() => ok()} className='btn btn-primary'>
                  <span className='indicator-label'>Yes</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {ConfirmModal}
